import { toPairs } from "lodash"

export const getPeripheralStatus = (state) => state?.peripheral?.peripheralStatus ?? 'ready'

const getInfo = (state, options = { target: '', json: true }) => {
  const targetInfoReceived = state?.peripheral?.[`${options?.target}Received`] ?? false
  const targetInfo = state?.peripheral?.[options?.target] ?? {}

  if (options?.json) return targetInfo

  let infoString = toPairs(targetInfo).map((pair) => pair.join(': ')).join(', ')

  if (targetInfoReceived && infoString !== '') {
    return infoString
  } else if (targetInfoReceived === false) {
    return 'Not Received'
  } else if (infoString === '') {
    return 'Not Found'
  }
}

export const getFirmwareInfo = (state, options = { json: true }) => {
  return getInfo(state, { target: 'firmwareInfo', ...options })
}

export const getBuildInfo = (state, options = { json: true }) => {
  return getInfo(state, { target: 'buildInfo', ...options })
}

export const getTerminalInfo = (state, options = { json: true }) => {
  return getInfo(state, { target: 'terminalInfo', ...options })
}
